import { Grid, Typography } from '@mui/material';
import React from 'react';
// import techWoman from '../../images/woman_using_laptop.png'
import '../../App.css'
import SVGGirlWithThoughtOrResume from './SVGGirlWithThoughtOrResume';

const AboutMe = ({data}) => {
    return(<Grid container spacing={{ md: 2 }}
    justifyContent="center" 
    alignItems="center"
    id="About Me">
        <Grid item xs={12} md={8} key="greeting_content">
        <Typography variant='body3'>{data}</Typography>
        </Grid>
        <Grid item xs={12} md={4} key="greeting_image">
        {/* <img src={techWoman} alt="Woman using computer"  width="125%" className='img-size-max-width-500 margin--12'/> */}
        <SVGGirlWithThoughtOrResume/>
        </Grid>
    </Grid>)
}

export default AboutMe;